export default __webpack_public_path__ + "static/electronic_white_board_w.2b9f8d05c69e1208b24a83324bca08ec.png";